module.exports = __webpack_public_path__ + "static/media/screenshot(22).7a136fb0.jpg";